var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['burger-icon', {'open': _vm.value}],on:{"click":function($event){$event.preventDefault();return _vm.switchValue.apply(null, arguments)}}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }